import '../node_modules/photoswipe/dist/photoswipe.css';
import '../node_modules/photoswipe/dist/default-skin/default-skin.css';
import './main.scss';

import '../node_modules/select2/dist/css/select2.min.css';
import '../node_modules/@ttskch/select2-bootstrap4-theme/dist/select2-bootstrap4.css';

import Swiper from 'swiper';
import CookiesEuBanner from 'cookies-eu-banner';
import _ from 'lodash';
import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import bsCustomFileInput from 'bs-custom-file-input'
import './js/photoswipe.js';

//import NewsApp from './js/NewsApp.vue';
import Countable from 'countable';
import jquery from 'jquery';
import select2 from "select2";
import focus from '@alpinejs/focus'
import persist from '@alpinejs/persist'

select2(jquery);

import Alpine from 'alpinejs';

Alpine.plugin(focus)
Alpine.plugin(persist)

window.$ = jquery;

var banner = new CookiesEuBanner(function(){
    (function(b,o,i,l,e,r){b.GoogleAnalyticsObject=l;b[l]||(b[l]=
    function(){(b[l].q=b[l].q||[]).push(arguments)});b[l].l=+new Date;
    e=o.createElement(i);r=o.getElementsByTagName(i)[0];
    e.src='https://www.google-analytics.com/analytics.js';
    r.parentNode.insertBefore(e,r)}(window,document,'script','ga'));
  ga('create', 'UA-29783754-10', 'auto');ga('send','pageview');ga('set', 'anonymizeIp', true);
});

window.loadSpruce = function(key, data) {
  Alpine.store(key, data);
}
loadSpruce('activeApp', {'urls': [], 'selectedURL': '', 'id': null});

window.toggleExtraFieldChecked = function (initial, condition) {
  return {
    value: initial,
    isOpen() { return condition(this.value); },
    init() {
      if (Array.isArray(initial)) {
        this.value = [...this.$el.querySelectorAll('[x-model="value"]:checked')].map(node => node.value);
      } else {
        let node = this.$el.querySelector('[x-model="value"]:checked');
        if (node) {
          this.value = node.value;
        }
      }
    },
  }
}

window.toggleExtraFieldSelected = function (initial, condition) {
  return {
    value: initial,
    isOpen() { return condition(this.value); },
    init() {
      if (Array.isArray(initial)) {
        this.value = [...this.$el.querySelectorAll('[x-model="value"] option[selected]')].map(node => node.value);
      } else {
        this.value = this.$el.querySelector('[x-model="value"] option[selected]').value;
      }
    },
  }
}


window.toggleFeedBackField = function () {
  return {
    value: '',
    rating: 0,
    open: false,
    isOpen() { return this.value || this.open; },
    init() {
      let node = this.$el.querySelector('[x-model="value"]');
      if (node) {
        this.value = node.value;
      } else {
        let text = this.$refs.value;
        this.value = text.innerHTML;
      }

      let rating = this.$el.querySelector('[x-model="rating"]:checked');
      if (rating) {
        this.rating = rating.value;
      }
    }
  }
}

window.TotalRating = function (initialRating) {
  // {rating: {'fgdfgg': {'rating': x, 'weight': x}}}
  return {
    rated() { return _.filter(_.values(this.rating), o => o.rating !== 0); },
    count() { return this.rated().length; },
    total() {
      let totalWeights = _.sumBy(this.rated(), o => o.weight);
      let total = _.sumBy(this.rated(), o => o.weight * o.rating) / totalWeights;
      return total.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    update(newRating) {
      // {label: 'fgdfgg', rating: x}
      this.rating[newRating.label].rating = parseInt(newRating.rating)
    },
    ...initialRating
  }
}

window.RankingButton = function () {
  return {
    setApp($dispatch, app) {
      let current = _.find(this.$store.apps, i => i.id === app);
      let currentApp = {
        id: current.id,
        urls: _.filter(current.urls, i => i.url !== null)
      };
      this.$store.activeApp = currentApp;
      this.$store.activeApp.selectedURL = current.urls[0].url;
      $dispatch('app-selected');
    }
  }
}

window.RankingIFrame = function () {
  return {
    init() {
      let el = this.$el;
      window.addEventListener('load', () => {
        Spruce.watch('activeApp.selectedURL',
          url => el.contentWindow.location.replace(url)
        )
      });
    }
  }
}

window.MainNavigation = function() {
  return {
    mobileOpen: false,
    isSticky: false,
    init() {
      let checkSticky = ([e]) => {
        this.isSticky = e.intersectionRatio < 1;
      };
      this.observer = new IntersectionObserver(checkSticky, {threshold: [1]});
      this.observer.observe(this.$el);
    },
  };
}

window.addEventListener('load', () => {
  try {
    var photogalleryOptions = {
      shareButtons: localizedShareButtons
    };
  } catch (ReferenceError) {
    var photogalleryOptions = {};
  }

  $.extend(photogalleryOptions, {
    itemFilter: function () {
      return $(this).parents('.slick-cloned').length === 0;
    },
    captionSelector: '.caption'
  });

  //$('.gallery').photogallery(photogalleryOptions);

  bsCustomFileInput.init();

  $('#nav-tab a').on('click', function (e) {
    e.preventDefault()
    $(this).tab('show')
  });

  $('.popup__links').on('click', function (e) {
    e.preventDefault();
    var modal = $(this).data("target");
    $(modal).modal("show");
    $(modal + ' .modal-body').load(
      $(this).attr("href") + ' .text-page-container',
      function () {
      }
    );
  });


  $('body').scrollspy({
    target: '#navbar-main'
  });

  if ($('.swiper-slideshow .swiper-slide').length > 1) {

    var gallerySwiper = new Swiper('.swiper-slideshow', {
      slidesPerView: 1,
      speed: 500,
      navigation: {
        prevEl: '.swiper-slideshow__arrow--prev',
        nextEl: '.swiper-slideshow__arrow--next',
        disabledClass: 'swiper-slideshow__arrow--disabled',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
    });

    $('.swiper-slideshow').hover(function (params) {
      gallerySwiper.autoplay.stop();
    }, function (e) {
      gallerySwiper.autoplay.start();
    });
  }

  var file = document.getElementById("id_moodboard");
  if (file) {
    file.onchange = function () {
      if (file.files.length > 0) {

        document.getElementsByClassName('file-name')[0].innerHTML = file.files[0].name;

      }
    };
  }

  if ($('.status').length) {
    var currentDate = new Date();

    var lightRefresh = function (params) {
      $.getJSON('/home/light-update/', function (data) {
        if (data.updated) {
          let newDate = new Date(data.updated);
          if (newDate > currentDate) {
            currentDate = newDate;
            $(window).scrollTop(0);
            setTimeout(() => {
              $('.status-container').load(window.location.href + ' .status');
            }, 1000);
          }
        }
      })
    };
    var lightUpdater = setInterval(lightRefresh, 5000);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        // tab is now inactive
        // temporarily clear timer using clearInterval() / clearTimeout()
        clearInterval(lightUpdater);
      }
      else {
        // tab is active again
        // restart timers
        lightUpdater = setInterval(lightRefresh, 5000);
      }
    });
  }
});

(function () {
  function CountableField(textarea) {
    var countDisplay = document.getElementById(textarea.id + "_counter");
    var countDown = false;
    var minCount, maxCount;
    if (textarea != null && countDisplay != null) {
      minCount = textarea.getAttribute("data-min-count");
      maxCount = textarea.getAttribute("data-max-count");

      Countable.on(textarea, updateCharatersLeft);
    }

    function updateCharatersLeft(counter) {
      var count = counter["all"];
      var left = maxCount - count;
      countDisplay.getElementsByClassName("text-count-current")[0].innerHTML = left;
      if (left < 0)
        countDisplay.className = "text-count text-is-over-max";
      else
        countDisplay.className = "text-count";
    }
  }

  document.addEventListener('DOMContentLoaded', function (e) {
    ;
    [].forEach.call(document.querySelectorAll('[data-count]'), CountableField)
  })
})()


Alpine.start();
